<template>
    <v-app class="white">
        <!-- 상단타이틀 -->
        <div class="top-bg">
             <!-- 배경 -->
            <img 
            src="@/assets/top_bg.png"
            class="img-top-bg"> 
            <!-- 타이틀 -->
            <div class="top-title">
                {{ $t('chage_password') }}
            </div> 
            <!-- 뒤로가기 버튼 -->
            <div class="top-backkey"
            @click.passive="onClickBack"
            v-ripple="{ center: true, class: `teal--text`  }">
                <img 
                src="@/assets/backkey.png"
                class="img-backkey"> 
            </div>  
        </div> 
        <!-- 내용 -->
        <div v-show="mMode == '1'" class="txt-pwd-reset">{{ $t('reset_passwd_new_pass') }}</div>
        <!-- 비밀번호 입력 -->
        <div class="txt-currnet-password" v-show="mMode == '0'">{{ $t('currnet_passwd') }}</div>
        <div class="input-pwd-currnet-position" 
        v-show="mMode == '0'">
            <img 
            src="@/assets/input_bg.png"
            class="img-input-pwd" 
            v-show="mMode == '0'"> 
            <input class="input-pwd-00" type="password" v-model="mPassCurrent" :placeholder=" $t('input_current_passwd') ">
        </div>
        <!-- 비밀번호 입력 -->
        <div class="txt-password">{{ $t('password') }}</div>
        <div class="input-pwd-position">
            <img 
            src="@/assets/input_bg.png"
            class="img-input-pwd"> 
            <input class="input-pwd-00" type="password" v-model="mPass00" :placeholder=" $t('input_password') ">
        </div>
       <!-- 비밀번호 재입력 -->
        <div class="txt-retry-password">{{ $t('re_password') }}</div>
        <div class="input-retry-pwd-position">
            <img 
            src="@/assets/input_bg.png"
            class="img-input-pwd"> 
            <input class="input-pwd-01" type="password" v-model="mPass01" :placeholder=" $t('input_password') ">            
        </div>
        <!-- 안내문구 -->
        <div class="txt-notice">{{ $t('charge_pass_notice_00') }}
            <br>{{ $t('charge_pass_notice_01') }} 
            <br>{{ $t('charge_pass_notice_02') }}
        </div>
        <!-- 다음버튼 -->
        <div class="btn-next-bg"
        @click.passive="onClickNext"
        v-ripple="{ center: true, class: `teal--text`  }">
            <div class="txt-next">{{ $t('charge_lbl') }}</div>
        </div>
        <!-- 로딩바 -->
        <div class="loading-bar-postion" v-show="mShowLoading">
            <v-progress-circular
            indeterminate
            color="red"
            ></v-progress-circular>
        </div>        
    </v-app>
</template>
<script>
import axios from 'axios';
import { constants } from 'crypto';
export default {
  created() {
    let payload = this.$route.query.payload;
    let decrypto = this.$cryptoUtil.decrptoMessage(payload);
    let json = JSON.parse(JSON.parse(decrypto));
    this.mMno = json.mno;
    this.mMode = json.mode;   
    console.log("this.mMode " + this.mMode);   
  },
  data: () => ({
      mPass00 : "",
      mPass01 : "",
      mRecomCode : "",
      mEmail : "",
      mSnsKey : "",
      mMarket : "AND",
      mLang : "KOR",
      mTokenID : "",
      mShowLoading : false,
      mPassCurrent : "",
      mMode : "0",
  }),
  methods : {
      onClickNext : function() {
            if(this.mPass00.length < 8) {
                alert("비밀번호 8자리 이상 넣어주세요.");
                return;
            }
            else if(this.mPass00.length >= 16) {
                alert("비밀번호 16자리 이하로 넣어주세요.");
                return;
            }
            else if(this.mPass00 != this.mPass01) {
                alert("재입력한 비밀번호가 틀립니다");
                return;
            }
            else if(this.mPass00 != this.mPass01) {
                alert("재입력한 비밀번호가 틀립니다");
                return;
            }
            // 비밀번호 문자열에 숫자 존재 여부 검사
            var pattern1 = /[0-9]/;  // 숫자
            if(pattern1.test(this.mPass00) == false) {
                let message = "비밀번호에 숫자가 입력되지 않았습니다.\n숫자를 입력하여 주시기 바랍니다.";
                alert(message);
                return;
            }
            // 비밀번호 문자열에 영문 소문자 존재 여부 검사
            var pattern2 = /[a-z]/;
            if(pattern2.test(this.mPass00) == false) {
                let message = "비밀번호에 영문 소문자가 입력되지 않았습니다.\n영문 소문자를 입력하여 주시기 바랍니다.";
                alert(message);
                return;
            }

            let payload = {};
            payload.cmd = "change-passwd";
            payload.mno = this.mMno;
            payload.passwd = this.$cryptoUtil.sha256Crypto(this.mPassCurrent);
            payload.passwd_new = this.$cryptoUtil.sha256Crypto(this.mPass00);

            this.mShowLoading = true;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                console.log(response);
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));  
                this.mShowLoading = false;
                if(serverResponse.result == "1") { // 성공
                   if(this.mMode == 1) {
                       alert("변경되었습니다.다시 로그인 해주세요.");
                       this.$router.push( { path : 'login'} );
                       return;
                   }
                   this.$router.go(-1);  
                } else if(serverResponse.result == "2") { // 기존비밀번호가 틀립니다.
                    alert("기존 비밀번호가 틀립니다.");
                } else if(serverResponse.result == "0") { // 오류
                    alert(serverResponse.message);
                }
            })
            .catch( ()=>{} );
        },
        onClickBack : function() {
            this.$router.go(-1);  
        }
  }
}
</script>
<style scoped>
* {
    margin: 0;
    font-family: "NanumBarunGothicOTF", "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
    font-weight: 300;
    padding: 0;
}
html, body {
    height: 100vh;
    width: 100vw;
}
.img-logo {
    height: 36.85vw;
    width: 63.9vw;
}
.logo-img-position {
    position: absolute;
    top: 39.6vh;
    left: 18.1vw;
}
.copyright-position {
    position: absolute;
    bottom: 4.2vh;
    left: 15.88889vw;
}
.img-copyright {
    height: 3.3vw;
    width: 68.5vw;
}
.top-bg {
    position: absolute;
    top: 0vh;
    left: 0vw;
    height: 13.24vw;
    width: 100vw;    
}
.img-top-bg {
    height: 13.24vw;
    width: 100vw;
}
.top-backkey {
    position: absolute;
    top: 0vh;
    left: 0vw;      
    height: 13.24vw;
    width: 13.24vw;
}
.img-backkey {
    position: absolute;
    top: 4.07vw;
    left: 5.64vw;
    height: 5.277vw;
    width: 2.77vw;
}
.top-title {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none;  
}
.btn-next-bg {
    position: fixed;
    bottom: 0px; 
    left: 0px;
    width: 100vw;
    height: 14.35vw; 
    background-color: #345993;
}
.txt-next {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: auto; 
    text-align: center;
    color: white;
    font-size: 4.148vw;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none; 
}
.txt-password {
    position: absolute;
    top: 37.35vw; 
    left: 5.9vw;
    color : #345993;
    font-size: 3.22vw;
    font-weight: bold;
    font-family: NanumBarunGothicOTF;
}
.input-pwd-position {
    position: absolute;
    top: 41.8vw; 
    left: 5.6vw;
}
.txt-currnet-password {
    position: absolute;
    top: 17.35vw; 
    left: 5.9vw;
    color : #345993;
    font-size: 3.22vw;
    font-weight: bold;
    font-family: NanumBarunGothicOTF;
}
.input-pwd-currnet-position {
    position: absolute;
    top: 21.8vw; 
    left: 5.6vw;
}
.img-input-pwd {
    height: 8.88vw;
    width: 88.9vw;
}
.txt-retry-password {
    position: absolute;
    top: 56.148vw; 
    left: 5.6vw;
    color : #345993;
    font-weight: bold;
    font-size: 3.22vw;
    font-family: NanumBarunGothicOTF;
}
.input-retry-pwd-position {
    position: absolute;
    top: 60.74vw; 
    left: 5.6vw;
}
.notice-text-00 {
    position: absolute;
    top: 53.37vw; 
    left: 6.1vw; 
    font-size: 2.7vw;
    font-weight: 300;
    font-family: NanumBarunGothicOTF; 
    color : #918b8a;      
}
.notice-text-01 {
    position: absolute;
    top: 57.4vw; 
    left: 6.1vw; 
    right: 6.1vw;
    width: auto;
    height: auto; 
    font-size: 2.7vw;
    font-weight: 300;
    font-family: NanumBarunGothicOTF; 
    color : #918b8a;     
}
.txt-recomm-code {
    position: absolute;
    top: 75.92vw; 
    left: 5.9vw;  
    color: #345993;   
    font-size: 3.22vw;
    font-weight: bold;
    font-family: NanumBarunGothicOTF;     
}
.input-recomm-positon {
    position: absolute;
    top: 80.55vw; 
    left: 5.9vw;      
}
.bottom-line {
    position: absolute;
    top: 70.92593vw; 
    left: 0vw;    
    width: 100vw;
    height: 5px;
    background-color: #f3f6fb;  
}
.input-pwd-00 {
    position: absolute;
    top: 20%; 
    left: 0vw;  
    width: 100%;
    height: auto;
    padding-left: 5vw;
    font-size: 3.2vw;
}
.input-pwd-01 {
    position: absolute;
    top: 20%; 
    left: 0vw;  
    width: 100%;
    height: auto;    
    padding-left: 5vw;
    font-size: 3.2vw;
}
.input-recom-code {
    position: absolute;
    top: 20%; 
    left: 0vw;  
    width: 100%;
    height: auto;    
    padding-left: 5vw;
    font-size: 3.2vw;
}
.loading-bar-postion {
    position: absolute;
    top: 50vh;
    left: 50vw; 
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
}
.txt-pwd-reset {
    position: absolute;
    top: 20vw; 
    left: 5vw;
    right: 5vw;
    opacity: 0.9;
    font-family: NanumBarunGothicOTF;
    font-size: 4vw;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #345993;
}
.txt-notice {
    position: absolute;
    top: 75vw; 
    left: 5vw;
    right: 5vw;
    opacity: 0.9;
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #345993; 
}
*:focus {
    outline: none;
}
</style>